<template>
  <div class="pagamento-successo">
    <div class="success-card">
      <div class="success-icon">✓</div>
      <h1>Pagamento Completato!</h1>
      <p class="success-message">Il tuo ordine d'asporto è stato ricevuto.</p>
      
      <div class="order-details" v-if="ordine">
        <h3>Riepilogo Ordine</h3>
        <div class="detail-row">
          <span>Numero Ordine:</span>
          <strong>{{ ordineId }}</strong>
        </div>
        <div class="detail-row">
          <span>Nome:</span>
          <strong>{{ ordine.nome }}</strong>
        </div>
        <div class="detail-row">
          <span>Contatto:</span>
          <strong>{{ ordine.contatto }}</strong>
        </div>
        <div class="detail-row">
          <span>Stato:</span>
          <span class="status-badge">{{ statoLabel }}</span>
        </div>
        <div class="items-list">
          <div class="item" v-for="(item, idx) in ordine.ordinazione" :key="idx">
            {{ item.quantita }}x {{ item.piatto }} - {{ (item.prezzo * item.quantita).toFixed(2) }}€
          </div>
        </div>
        <div class="total-row">
          <span>Totale Pagato:</span>
          <strong>{{ (ordine.totale / 100).toFixed(2) }}€</strong>
        </div>
      </div>

      <p class="info-text">
        Ti contatteremo quando l'ordine sarà pronto per il ritiro.
      </p>

      <button class="btn-home" @click="goHome">Torna alla Home</button>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'PagamentoSuccesso',
  data() {
    return {
      store,
      ordineId: null,
      ordine: null,
      pollInterval: null
    }
  },
  computed: {
    statoLabel() {
      const stati = {
        'pendente': 'In attesa',
        'pagato': 'Pagato',
        'in_preparazione': 'In preparazione',
        'pronto': 'Pronto per il ritiro',
        'consegnato': 'Consegnato'
      }
      return stati[this.ordine?.stato] || this.ordine?.stato
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'Benvenuto' })
    },
    async fetchOrder() {
      if (!this.ordineId) return
      try {
        const response = await this.axios.get(
          this.store.path + 'getOrdineAsporto/' + this.ordineId
        )
        if (response.data.messaggio) {
          const nuovoOrdine = response.data.messaggio
          this.ordine = nuovoOrdine
          
          // Stop polling if order is delivered
          if (nuovoOrdine.stato === 'consegnato') {
            this.stopPolling()
          }
        }
      } catch (error) {
        console.error('Error fetching order:', error)
      }
    },
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval)
        this.pollInterval = null
      }
    }
  },
  mounted() {
    this.ordineId = this.$route.query.ordine
    this.fetchOrder()
    // Poll every 5 seconds
    this.pollInterval = setInterval(this.fetchOrder, 5000)
  },
  beforeUnmount() {
    this.stopPolling()
  }
}
</script>

<style scoped>
.pagamento-successo {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.success-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  color: white;
}

.success-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #00ff88, #00d9ff);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  margin: 0 auto 20px;
  color: #1a1a2e;
}

h1 {
  color: #00ff88;
  margin-bottom: 10px;
}

.success-message {
  color: #aaa;
  font-size: 1.1rem;
  margin-bottom: 30px;
}

.order-details {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 20px;
  text-align: left;
  margin-bottom: 20px;
}

.order-details h3 {
  color: #00d9ff;
  margin-bottom: 15px;
  text-align: center;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.status-badge {
  background: #00ff88;
  color: #1a1a2e;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: bold;
}

.items-list {
  margin: 15px 0;
  padding: 10px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.item {
  padding: 5px 0;
  color: #ccc;
}

.total-row {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  font-size: 1.2rem;
}

.total-row strong {
  color: #00ff88;
}

.info-text {
  color: #888;
  font-size: 0.95rem;
  margin-bottom: 25px;
}

.btn-home {
  background: linear-gradient(90deg, #00d9ff, #00ff88);
  border: none;
  padding: 14px 40px;
  border-radius: 8px;
  color: #1a1a2e;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s;
}

.btn-home:hover {
  transform: translateY(-2px);
}
</style>
